<template>
    <div class="monitor">
        <monitor-top></monitor-top>
        <div class="monitor-main">
            <baidu-map :ak="ak" :zoom="zoom" :center="center" :markers="markers" :map-style="mapStyle" ref="BaiduMap" @ready="handleMapReady" @zoomChange="handleChangeZoom"></baidu-map>
            <monitor-left></monitor-left>
            <monitor-right></monitor-right>
            <monitor-button-group></monitor-button-group>
        </div>
    </div>
</template>

<script>
import MonitorTop from './partials/MonitorTop'
import MonitorLeft from './partials/MonitorLeft'
import MonitorRight from './partials/MonitorRight'
import MonitorButtonGroup from './partials/MonitorButtonGroup'
import constant from "../../utils/constant";
import xhr from "../../utils/xhr";
import Status2CN from "../../filters/Status2CN";

const getRepaymentCountYear = function ( repaymentCount) {
    let repaymentYear = repaymentCount + '月期'
    switch (repaymentCount) {
        case '12' : repaymentYear = '一年期';break;
        case '24' : repaymentYear = '两年期';break;
        case '36' : repaymentYear = '三年期';break;
        case '48' : repaymentYear = '四年期';break;
        case '60' : repaymentYear = '五年期';break;
        case '72' : repaymentYear = '六年期';break;
        case '84' : repaymentYear = '七年期';break;
        case '96' : repaymentYear = '八年期';break;
    }
    return repaymentYear
}

const getPercent = function (balance, total) {
    balance = Number(balance) || 0
    total = Number(total) || 0

    return Math.floor(100 * ( (total-balance) / (total||1) ) )
}

/**
 * 格式化金额为万元
 * @param total
 * @param digt
 * @returns Number
 */
const formatWanYuan = function (total, digt =0,) {
    return parseInt(((parseInt(total)) /10000).toFixed(digt))
}

let timer = null

export default {
    name: "Monitor",
    components: {
        MonitorTop,
        MonitorLeft,
        MonitorRight,
        MonitorButtonGroup
    },
    data() {
        return {
            ak: constant.BaiduMap.ak || '',
            mapStyle: {
                styleId: constant.BaiduMap.styleId || '',
            },
            center: constant.BaiduMap.center || [120.30565557161933, 31.547000226020288],
            infoBox: null,
            zoom: 13,
            zoomObj: {
                8: {
                    width: 70 * 0.12,
                    height: 70 * 0.12
                },
                9: {
                    width: 70 * 0.16,
                    height: 70 * 0.16
                },
                10: {
                    width: 70 * 0.2,
                    height: 70 * 0.2
                },
                11: {
                    width: 70 * 0.23,
                    height: 70 * 0.23
                },
                12: {
                    width: 70 * 0.25,
                    height: 70 * 0.25
                },
                13: {
                    width: 70 * 0.31,
                    height: 70 * 0.31
                },
                14: {
                    width: 70 * 0.6,
                    height: 70 * 0.6
                },
                15: {
                    width: 70 * 0.8,
                    height: 70 * 0.8
                },
                16: {
                    width: 70 * 0.9,
                    height: 70 * 0.9
                }
            },
            iconImages: [
                require('@/assets/icon/circle_n_1.svg'),
                require('@/assets/icon/circle_n_2.svg'),
                require('@/assets/icon/circle_n_3.svg'),
                require('@/assets/icon/circle_n_4.svg'),
                require('@/assets/icon/circle_n_5.svg'),
            ],
            iconAnimationImages: [
                require('@/assets/icon/circle_3_3.svg'),
                require('@/assets/icon/circle_3_3.svg'),
                require('@/assets/icon/circle_3_3.svg'),
                require('@/assets/icon/circle_3_3.svg'),
                require('@/assets/icon/circle_3_3.svg'),
            ],
        }
    },
    watch: {
        zoom: function (newVal) {
            console.log('zoom', newVal)
        }
    },
    mounted() {
    },
    computed: {
        //大屏数据
        monitorData() {
            return this.$store.state.monitorData||{}
        },
        //小区列表
        propertyLocationList() {
            return this.monitorData.propertyLocationList||[]
        },
        //大屏事件列表
        eventList() {
            return this.monitorData.eventList || []
        },
        //大屏事件涉及的小区，移除重复的小区
        eventLocationList() {
            return [...new Set(this.eventList.reduce((total, item) => {
                total = total.concat( (item.e__locationName||'').split(','))
                return total
            }, []))]
        },
        markers() {
            //当前地图上最小贷款笔数作为基准点
            const minCount = Math.min(...(this.propertyLocationList.map(item=>(Number(item.fi__counts)||0))))
            //当前地图上最大贷款笔数作为最大点
            const maxCount = Math.max(...(this.propertyLocationList.map(item=>(Number(item.fi__counts)||0))))

            //当前地图上最小平均单价
            const minAvgerageAmount = Math.min(...(this.propertyLocationList.map(item=>(Number(item.fi__avgerageAmount)||0))))
            //当前地图上最大平均单价
            const maxAvgerageAmount = Math.max(...(this.propertyLocationList.map(item=>(Number(item.fi__avgerageAmount)||0))))

            //当前标记点的基准大小
            const iconBaseSize = this.zoom < 8 ? {width: 70 * 0.1, height: 70 * 0.1} : Math.floor(this.zoom)<=16 ? this.zoomObj[Math.floor(this.zoom)] : {
                width: 70 ,
                height: 70
            }

            return this.propertyLocationList.map(item=>{
                //当前小区的贷款笔数
                const currentCounts = Number(item.fi__counts)||0
                //当前小区的平均单价
                const currentAvgerageAmount = Number(item.fi__avgerageAmount)||0
                //当前小区基准比率
                const sizeRate = 1 + 1 * (currentCounts - minCount) / (maxCount - minCount)

                //当前标记点的ICON
                const icon = {
                    image: this.getIconByAvgerageAmount(currentAvgerageAmount, this.eventLocationList.includes(item.lo__locationName)),
                    // image: 'http://webmap0.bdimg.com/image/api/marker_red.png',
                    size: {
                        width: iconBaseSize.width * sizeRate,
                        height: iconBaseSize.height * sizeRate
                    }
                }

                return {
                    position: {
                        lng: item.lo__longitude,
                        lat: item.lo__latitude
                    },
                    icon,
                    events: {
                        click: ()=> {
                            this.handleClickMarker(item)
                        },
                        //鼠标移上标记点ICON放大两倍
                        mouseover: ({marker})=> {
                            const markerIcon = marker.getIcon()
                            marker.setIcon(new BMap.Icon(icon.image || null, new BMap.Size(markerIcon.size.width * 2, markerIcon.size.height * 2)))
                        },
                        //鼠标移走恢复原样
                        mouseout: ({marker}) => {
                            marker.setIcon(new BMap.Icon(icon.image || null, new BMap.Size(icon.size.width, icon.size.height)))
                        }
                    },
                    animation: this.eventLocationList.includes(item.lo__locationName)
                }
            })
        }
    },
    methods:{
        /**
         * 地图加载成功之后执行
         */
        handleMapReady: function ({BMap, map}) {
            this.BMap  = BMap
            this.map = map

            this.getFinancingByPropertyLocationList()
        },
        /**
         * InfoBox 渲染
         * @param data 数据
         * @param position
         * @param boxHtml
         * @param opts
         * @param trigger
         */
        renderInfoBox: function (position={}, boxHtml='', data=[], opts={}, trigger='click') {
            const BMap = this.BMap

            if (this.infoBox) {
                this.infoBox.close()
            }

            const point = new BMap.Point(position.lng, position.lat)
            const option = Object.assign({
                boxStyle:{
                    width: "auto",
                    height: "auto",
                    'margin-bottom': '80px'
                }// ,
                // boxClass: 'map-dialog'
                ,closeIconMargin: "20px 20px 0 0"
                ,closeIconUrl: require('@/assets/icon/close.png')
                ,align: INFOBOX_AT_BOTTOM
            }, opts)

            const InfoBox = new BMapLib.InfoBox(this.map, boxHtml, option);

            InfoBox.trigger = trigger

            InfoBox.open(point)

            //商品关闭时继续开始轮播
            InfoBox.addEventListener("close", ()=> {
            });

            //点击地图时候关闭INFOBOX
            // this.map.removeEventListener('click')
            // this.map.addEventListener('click', function() {
            //     InfoBox.close()
            // });

            this.infoBox = InfoBox

            this.renderChart('echart06', data)
        },
        renderChart: function (id='', data=[]) {
            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById(id));

            // 指定图表的配置项和数据
            var option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                    textStyle:{
                        fontSize:24,
                        color:'#96dcff'
                    }
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    // data: ['一年限', '二年限', '三年限', '五年限', '八年限'],
                    data: data.map(item=>getRepaymentCountYear(item.fi__repaymentCount)),
                    textStyle:{
                        fontSize:24,
                        color:'#96dcff'
                    }
                },
                series: [
                    {
                        name: '统计',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ["35%", "50%"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '20',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: data.map(item=>({
                            value: item.fi__counts,
                            name: getRepaymentCountYear(item.fi__repaymentCount)
                        }))
                        // data: [
                        //     {value: 335, name: '一年限'},
                        //     {value: 310, name: '二年限'},
                        //     {value: 154, name: '三年限'},
                        //     {value: 234, name: '五年限'},
                        //     {value: 135, name: '八年限'},
                        // ]
                    }
                ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        /**
         * 拿全部小区
         */
        getFinancingByPropertyLocationList: function () {
            xhr.getFinancingByPropertyLocationList({pageSize: 0}, ({data}) => {
                if (data.status === 'success') {
                    this.$store.commit('setPropertyLocationList', data.data||[])
                }

                timer = setTimeout(this.getFinancingByPropertyLocationList, 30*1000)
            })
        },
        /**
         * 点击标记点事件
         * @param marker
         */
        handleClickMarker: function (marker) {
            const point = {
                lng: marker.lo__longitude,
                lat: marker.lo__latitude
            }
            const locationName = marker.lo__locationName || ''
            xhr.getFinancingByPropertyLocationIIIList(locationName, ({data}) => {
                if (data.status === 'success') {
                    const ProcessingCount = ((data.data||[]).find(item=>item.fi__transactionStatus === 'Processing')||{}).fi__counts||0
                    const CompletedCount = ((data.data||[]).find(item=>item.fi__transactionStatus === 'Settled')||{}).fi__counts||0


                    xhr.getFinancingByPropertyLocationIIList(locationName, ({data}) => {

                        if (data.status === 'success') {
                            const locationData = (data.data || [])

                            xhr.getFinancingByPropertyLocationIVList(locationName, ({data}) => {
                                if (data.status === 'success') {
                                    const repayList = data.data||[]

                                    let boxHtml = `<div class="map-dialog-box">
                            <div class="map-dialog-box-head"><h2>${locationName}</h2></div>
                            <div class="map-dialog-box-main">
                                <div id="echart06" style="width: 420px;height:240px;margin:0 auto"></div>
                                <div class="location-mesg">
                                    <div class="location-mesg-left">
                                        <div class="location-mesg-text">还款中(笔)</div>
                                        <div class="location-mesg-number">${ProcessingCount}</div>
                                    </div>
                                    <div class="location-mesg-mid"></div>
                                    <div class="location-mesg-right">
                                        <div class="location-mesg-text">已还清(笔)</div>
                                        <div class="location-mesg-number">${CompletedCount}</div>
                                    </div>
                                </div>
                                <div class="new_list" style="height: auto;">`;
                                    (this.eventList.filter(item=>item.e__locationName === locationName)||[]).forEach(item=> {
                                        const logTime = this.$moment(item.e__logTime).format('MM-DD HH:mm')
                                        boxHtml += `
                                    <div class="new_list_item">
                                        <p class="time">${logTime}</p>
                                        <p class="text">${item.e__description}</p>
                                    </div>
                                    `;
                                    })
                                    boxHtml += `
                                </div>
                                <div class="loan-list">`;
                                    if (repayList.length > 0 ) {
                                        repayList.slice(0,10).forEach(item=> {
                                            const percent = getPercent(item.fi__balanceAmount, item.fi__totalAmount)
                                            const totalAmount = formatWanYuan(item.fi__totalAmount)
                                            const status = Status2CN('Financing_' + item.fi__transactionStatus) || item.fi__transactionStatus
                                            const statusClass = item.fi__transactionStatus === 'Settled' ? 'y' : 'w'

                                            boxHtml += `<div class="loan-list-item">
                                        <div class="loan-static ${statusClass}">${status}</div>
                                        <div class="loan-name">${item.fi__customerName}</div>
                                        <div class="loan-porgress">
                                            <div class="loan-progress-inner" style="width: ${percent}%">
                                                <div class="loan-progress-innerText">&nbsp;</div>
                                            </div>
                                        </div>
                                        <div class="loan-money">${totalAmount}万元</div>
                                    </div>`
                                        })
                                    }

                                    boxHtml += `
                                </div>
                            </div>
                        </div>`

                                    this.renderInfoBox(point, boxHtml, locationData)
                                }
                            })
                        }
                    })
                }
            })
        },
        handleChangeZoom: function (newVal) {
            this.zoom = newVal
        },
        /**
         * 根据贷款金额显示ICON
         * @param avgerageAmount 贷款平均金额
         * @param animation 是否动画
         * @returns {*}
         */
        getIconByAvgerageAmount: function(avgerageAmount = 0, animation=false) {
            avgerageAmount = Number(avgerageAmount) || 0
            let iconIndex = 0

            if (avgerageAmount >= 100 * 10000) {
                iconIndex = 4
            }
            else if (avgerageAmount >= 50* 10000) {
                iconIndex = 3
            }
            else if (avgerageAmount >= 20 * 10000) {
                iconIndex = 2
            }
            else if (avgerageAmount >= 10 * 10000) {
                iconIndex = 1
            }

            return animation ? this.iconAnimationImages[iconIndex] : this.iconImages[iconIndex]
        }
    },
    destroyed() {
        timer && clearTimeout(timer)
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/monitor/index.vue